$('#ocupacion_cliente').autoComplete({
    resolver:'custom',
    bootstrapVersion:"4",
    events: {
        search:function (qry, callback) {
            $.ajax({
                url: url_base+"/api/ocupacionAutocomplete",
                dataType: 'json',
                data: {
                    'qry': qry
                },
                beforeSend: function(){
                },
                error: function(){
                    console.error("error");
                },
                success: function(data){
                    callback(data);
                }
            });
        }
    }
});
$('#nombre_cliente').autoComplete({
    resolver:'custom',
    minLength:2,
    noResultsText: "No hay clientes con este nombre",
    bootstrapVersion:"4",
    events: {
        search:function (qry, callback) {
            $.ajax({
                url: url_base+"/api/clienteAutocomplete",
                dataType: 'json',
                data: {
                    'qry': qry
                },
                beforeSend: function(){
                },
                error: function(){
                    console.error("error");
                },
                success: function(data){
                    callback(data);
                    console.log(data);
                }
            });
        }
    }
}).on('autocomplete.select', function (evt, item) {
    console.log("Opción seleccionada:", item);
    $("#cliente-orden-id").val(item.value);
});

quitarFiltrosClientes = function(){
    $("input[name=desde]").val("");
    $("input[name=hasta]").val("");
    $("#filtro_estatus").val("");
    $("#filtro_ocupaciones").val("");
    $("#form_filtrar_clientes")[0].submit();
}
cancelarBusquedaClientes = function(){
    $("input[name=busqueda]").val("");
    $("#form_filtrar_clientes")[0].submit();
}

$("#ordenes_pago").on('change',function(e){
    const select = document.getElementById('ordenes_pago');
    const options = select.selectedOptions;
    let totalSaldo = 0;
    for (let i = 0; i < options.length; i++) {
        totalSaldo += parseFloat(options[i].getAttribute('data-saldo'));
    }
    if(totalSaldo)
        document.getElementById('suma_restantes').textContent = '$'+totalSaldo;
    else
        document.getElementById('suma_restantes').textContent = '';
})

eliminarCliente = function(e){
    var data = e.dataset;
    $("#form_eliminar_cliente")[0].reset();
    $("#eliminar_cliente_id").val(data.id);
    $("#eliminar_cliente_nombre").html(`¿Deseas eliminar a <strong>${data.nombre}</strong>?`);
}